import WithdrawWallet from "../../components/admin/WithdrawWallet";

export default function WithdrawWalletPage() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Withdrawal Wallets</h1>
      <WithdrawWallet />
    </div>
  );
}
